/**
 * Fiko-Analiz-Radius Sistemi
 * CNC Radius Analizi - CATIA Seviyesi
 * Takım erişilebilirlik ve minimum radius analizi
 */

import * as THREE from 'three';
import { RadiusAnalysisComponent } from './radius-analysis.component';

// Main Classes
export { RadiusAnalysisComponent } from './radius-analysis.component';

// Types and Interfaces
export interface ToolConfiguration {
    toolType: 'ball' | 'flat' | 'bullnose' | 'chamfer';
    radius: number;
    cornerRadius?: number;
    angle?: number;
}

export interface RadiusAnalysisSettings {
    toolConfig: ToolConfiguration;
    minRadius: number;
    maxRadius: number;
    showHeatmap: boolean;
}

// Standalone Component Declarations 
export const FIKO_RADIUS_ANALIZ_COMPONENTS = [
    RadiusAnalysisComponent
];

// Version Information
export const FIKO_RADIUS_ANALIZ_VERSION = '1.0.0';
export const FIKO_RADIUS_ANALIZ_INFO = {
    name: 'Fiko-Radius-Analiz Sistemi',
    version: FIKO_RADIUS_ANALIZ_VERSION,
    description: 'CNC Radius Analizi - CATIA Seviyesi Takım Erişilebilirlik Analizi',
    features: [
        'GPU accelerated shader-based radius analizi',
        'Takım tipi seçimi (Ball, Flat, Bullnose, Chamfer)',
        'Gerçek zamanlı radius hesaplama',
        'Riskli alan tespiti',
        'Özelleştirilebilir takım yarıçapı',
        'Renk kodlu heatmap görselleştirme',
        'İstatistiksel analiz sonuçları'
    ]
};

// Utility Functions
export const FikoRadiusAnalizUtils = {
    /**
     * Varsayılan radius analiz ayarları oluştur
     */
    createDefaultAyarlar(): RadiusAnalysisSettings {
        return {
            toolConfig: {
                toolType: 'ball',
                radius: 5.0
            },
            minRadius: 0.1,
            maxRadius: 50.0,
            showHeatmap: true
        };
    },

    /**
     * Takım tipi için renk kodu döndür
     */
    getToolTypeColor(toolType: string): string {
        switch (toolType) {
            case 'ball':
                return '#4CAF50';
            case 'flat':
                return '#2196F3';
            case 'bullnose':
                return '#FF9800';
            case 'chamfer':
                return '#9C27B0';
            default:
                return '#757575';
        }
    },

    /**
     * Radius değerine göre risk durumu belirle
     */
    riskDurumuBelirle(radius: number, toolRadius: number): 'guvenli' | 'uyari' | 'tehlikeli' | 'erisilemez' {
        if (radius < toolRadius * 0.4) {
            return 'erisilemez';
        } else if (radius < toolRadius) {
            return 'tehlikeli';
        } else if (radius < toolRadius * 2) {
            return 'uyari';
        } else {
            return 'guvenli';
        }
    },

    /**
     * Risk durumuna göre renk döndür
     */
    getRiskColor(durum: 'guvenli' | 'uyari' | 'tehlikeli' | 'erisilemez'): THREE.Color {
        switch (durum) {
            case 'guvenli':
                return new THREE.Color(0x00BCD4);
            case 'uyari':
                return new THREE.Color(0xFFEB3B);
            case 'tehlikeli':
                return new THREE.Color(0xF44336);
            case 'erisilemez':
                return new THREE.Color(0x9C27B0);
            default:
                return new THREE.Color(0x757575);
        }
    }
};

// THREE.js dependency (export for external use)
export * from 'three';
